export default __webpack_public_path__ + "static/media/DentalCharting.7d71dca9.png";